/**
 * Technology Validation Schemas
 */

import { z } from 'zod';
import { emptyToUndefined, nameField, optionalBoundedText } from './shared';

export const technologyValidationRules = {
  name: nameField(
    200,
    'Technology name is required',
    'Technology name must be less than 200 characters'
  ),

  description: optionalBoundedText(2000, 'Description must be less than 2000 characters'),

  version: optionalBoundedText(50, 'Version must be less than 50 characters'),

  supplierId: emptyToUndefined(z.string().min(1).optional()),

  notes: optionalBoundedText(5000, 'Notes must be less than 5000 characters'),
};

export const createTechnologySchema = z.object({
  name: technologyValidationRules.name,
  description: technologyValidationRules.description,
  productFamilyId: z.string().optional(),
  version: technologyValidationRules.version,
  lifecycleStage: z.enum(['Adopt', 'Hold', 'Evaluate', 'Sunset']).optional(),
  supplierId: technologyValidationRules.supplierId,
  licenseType: emptyToUndefined(
    z.enum(['open-source', 'commercial', 'enterprise', 'custom']).optional()
  ),
  supportEndDate: z.string().optional(),
  securityRating: emptyToUndefined(z.enum(['high', 'medium', 'low']).optional()),
  notes: technologyValidationRules.notes,
});

export const updateTechnologySchema = z
  .object({
    name: technologyValidationRules.name.optional(),
    description: technologyValidationRules.description,
    productFamilyId: z.string().optional(),
    version: technologyValidationRules.version,
    lifecycleStage: z.enum(['Adopt', 'Hold', 'Evaluate', 'Sunset']).optional(),
    supplierId: technologyValidationRules.supplierId,
    licenseType: emptyToUndefined(
      z.enum(['open-source', 'commercial', 'enterprise', 'custom']).optional()
    ),
    supportEndDate: z.string().optional(),
    securityRating: emptyToUndefined(z.enum(['high', 'medium', 'low']).optional()),
    notes: technologyValidationRules.notes,
  })
  .refine((data) => Object.values(data).some((value) => value !== undefined), {
    message: 'At least one field must be updated',
  });

export type CreateTechnologyFormData = z.infer<typeof createTechnologySchema>;

export type UpdateTechnologyFormData = z.infer<typeof updateTechnologySchema>;
